var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "money",
    d: "M7.875-8.469A2.691,2.691,0,0,1,10-9.5a2.691,2.691,0,0,1,2.125,1.031A3.691,3.691,0,0,1,13-6a3.691,3.691,0,0,1-.875,2.469A2.691,2.691,0,0,1,10-2.5,2.691,2.691,0,0,1,7.875-3.531,3.69,3.69,0,0,1,7-6,3.69,3.69,0,0,1,7.875-8.469ZM11.25-4.25v-.5A.221.221,0,0,0,11-5h-.5V-7.75A.221.221,0,0,0,10.25-8H9.813a.718.718,0,0,0-.406.125l-.469.313a.27.27,0,0,0-.125.219.18.18,0,0,0,.063.125l.25.438a.3.3,0,0,0,.219.094A.348.348,0,0,0,9.5-6.719V-5H9a.221.221,0,0,0-.25.25v.5A.221.221,0,0,0,9-4h2A.221.221,0,0,0,11.25-4.25ZM19-12a.961.961,0,0,1,.7.3.961.961,0,0,1,.3.7V-1a.961.961,0,0,1-.3.7A.961.961,0,0,1,19,0H1A.961.961,0,0,1,.3-.3.961.961,0,0,1,0-1V-11a.961.961,0,0,1,.3-.7A.961.961,0,0,1,1-12Zm-.5,8.5v-5a1.933,1.933,0,0,1-1.422-.578A1.933,1.933,0,0,1,16.5-10.5H3.5a1.933,1.933,0,0,1-.578,1.422A1.933,1.933,0,0,1,1.5-8.5v5a1.933,1.933,0,0,1,1.422.578A1.933,1.933,0,0,1,3.5-1.5h13a1.933,1.933,0,0,1,.578-1.422A1.933,1.933,0,0,1,18.5-3.5Z",
    transform: "translate(0 12)",
    fill: "#0a0a0a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.b3b74475bcc3e9c6c48e478a6a321ccc.svg";
export { ForwardRef as ReactComponent };